import { observable, action, runInAction } from 'mobx';
import { uniq, cloneDeep, isEmpty } from 'lodash';
import { round } from 'mathjs';

import { locateValue } from '@tool/index';

const moJob = observable({
  list1: <any[]>[], // 第一页数据
  lists: <any[]>[],
  pageNum: 1,
  updateTime: '',
});

// 获取数据更新时间
const initUpdateTime = action((res: any) => {
  if (isEmpty(res)) return;

  moJob.updateTime = res.HRIndicator;
});

const initHotJob = action(async (res: any) => {
  // console.log('热门职位 -- ', res);
  if (isEmpty(res)) return;

  let industryOne: any[] = [];
  const tempOne: any[] = [];
  const arr1: any[] = [];
  const lists: any[] = [];
  const tempArr1: any[] = [];
  let pageNum = 1;

  if (res.length > 26) pageNum = Math.ceil(res.length / 26);

  res.map((item: any) => {
    tempOne.push(item.industry);
  });

  industryOne = uniq(tempOne);

  // 第一页数据
  industryOne.map((industryName: any) => {
    const tempArr: any[] = [];
    res.slice(0, 26).map((item: any) => {
      if (item.industry === industryName) {
        tempArr.push(item);
      }
    });
    tempArr1.push({
      industry: industryName,
      arr: tempArr,
    });
  });

  // 第一页之后的数据
  const temp: any[] = [];
  for (let i = 0; i < pageNum - 1; i += 1) {
    temp.push(res.slice(26 * (i + 1), (i + 1) * 26 + 30));
  }

  temp.map((item: any) => {
    const names: any[] = [];
    const newArr: any[] = [];
    item.map((child: any) => names.push(child.industry));
    uniq(names).map((industryName: any) => {
      const tempArr: any[] = [];
      item.map((child: any) => {
        if (industryName === child.industry) tempArr.push(child);
      });
      newArr.push({
        industry: industryName,
        arr: tempArr,
      });
    });
    lists.push(newArr);
  });

  tempArr1.map((item: any) => {
    if (!isEmpty(item.arr)) arr1.push(item);
  });

  // console.log('行业 -- ', industryOne);
  // console.log('list1 -- ', arr1);
  // console.log('lists -- ', lists);

  runInAction(() => {
    moJob.list1 = arr1;
    moJob.lists = lists;
  });
});

export default moJob;
export { initHotJob, initUpdateTime };
